import Details from 'components/orders/Details';
import { Card } from 'antd';
import { IOrder } from '../../../interfaces/orders';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { SalesIconComponent } from 'assets/icons/sales';
import { ShowLayout } from '../../../components/layout/layout/ShowLayout';
import { useShow } from '@refinedev/core';

export const OrderShow = () => {
  const { queryResult } = useShow<IOrder>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader title="Visualizar Pedido" icon={SalesIconComponent} />
      <Card>{record && <Details order={record} />}</Card>
    </ShowLayout>
  );
};
